export default __webpack_public_path__ + "static/media/pop-up2.b4e9d994.jpeg";